import * as Styles from "layouts/PrivateLayout.styles"
import {Typography} from "@mui/material"
import {Link} from "react-router-dom"
import {ArrowOutward} from "@mui/icons-material";
import {IBookingSlot} from "services/bookingSlots";

const BookingDetailsCustomerData: React.FC<IBookingSlot | any> = ({ booking }) => {
    const customerData = booking?.customer
    
    return <>
        <Styles.FlexContainer flex-col>
            <Styles.FlexContainerColumn>
                <Typography sx={{ fontSize: 16, paddingBottom: 1 }} gutterBottom>
                    {customerData?.name}
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn>
                <Typography sx={{ fontSize: 16, fontWeight: 'bold' }} color="text.secondary" gutterBottom>
                    Email
                </Typography>
                <Typography sx={{ fontSize: 16, paddingBottom: 1 }} color="text.secondary" gutterBottom>
                    {/*<Link to={""} className="text-blue-500 font-medium">*/}
                        <span className="pr-1">{customerData?.email}</span>
                        {/*<ArrowOutward />*/}
                    {/*</Link>*/}
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn>
                <Typography sx={{ fontSize: 14, fontWeight: 'bold' }} color="text.secondary" gutterBottom>
                    Phone
                </Typography>
                <Typography sx={{ fontSize: 16, paddingBottom: 1 }} color="text.secondary" gutterBottom>
                    {/*<Link to={""} className="?text-blue-500 font-medium">*/}
                        <span className="pr-1">{customerData?.phone}</span>
                        {/*<ArrowOutward />*/}
                    {/*</Link>*/}
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn>
                <Typography sx={{ fontSize: 14, fontWeight: 'bold' }} color="text.secondary" gutterBottom>
                    Shopify Customer
                </Typography>
                <Typography sx={{ fontSize: 16, paddingBottom: 1 }} color="text.secondary" gutterBottom>
                    {/*<Link to={""} className="text-blue-500 font-medium">*/}
                        <span className="pr-1">{customerData?.shopify_customer_id}</span>
                        {/*<ArrowOutward />*/}
                    {/*</Link>*/}
                </Typography>
            </Styles.FlexContainerColumn>
            <Styles.FlexContainerColumn>
                <Typography sx={{ fontSize: 16, fontWeight: 'bold' }} color="text.secondary" gutterBottom>
                    Default Address
                </Typography>
                <Typography sx={{ fontSize: 13 }} color="text.secondary" gutterBottom>
                    {customerData?.name}
                </Typography>
                <Typography sx={{ fontSize: 13 }} color="text.secondary" gutterBottom>
                    {customerData?.address_1}
                </Typography>
                <Typography sx={{ fontSize: 13 }} color="text.secondary" gutterBottom>
                    {customerData?.city} {customerData?.state} {customerData?.zip_code} 
                </Typography>
                <Typography sx={{ fontSize: 13 }} color="text.secondary" gutterBottom>
                    United States
                </Typography>
                <Typography sx={{ fontSize: 13 }} color="text.secondary" gutterBottom>
                    {customerData?.phone}
                </Typography>
            </Styles.FlexContainerColumn>
        </Styles.FlexContainer>
    </>
}

export default BookingDetailsCustomerData
